import { call, put, takeLatest } from 'redux-saga/effects';
import { apiClient } from '../../utils/axios';
import {
  fetchComplianceRequest,
  fetchComplianceSuccess,
  fetchComplianceFailure,
  fetchRejectionRequest,
  fetchRejectionSuccess,
  fetchRejectionFailure,
} from './dashboardSlice';

function* fetchComplianceSaga(action) {
  try {
    const { startDate, endDate } = action.payload;
    const response = yield call(apiClient.get, `/dashboard/compliance`, {
      params: { startDate, endDate },
    });

    yield put(fetchComplianceSuccess(response.data));
  } catch (error) {
    yield put(fetchComplianceFailure(error.response?.data?.message || 'Failed to fetch compliance data'));
  }
}

function* fetchRejectionSaga(action) {
  try {
    const { startDate, endDate } = action.payload;
    const response = yield call(apiClient.get, `/dashboard/rejections`, {
      params: { startDate, endDate },
    });

    yield put(fetchRejectionSuccess(response.data));
  } catch (error) {
    yield put(fetchRejectionFailure(error.response?.data?.message || 'Failed to fetch rejection data'));
  }
}

export default function* dashboardSaga() {
  yield takeLatest(fetchComplianceRequest.type, fetchComplianceSaga);
  yield takeLatest(fetchRejectionRequest.type, fetchRejectionSaga);
}
